@if (item) {
  <div class="accordion-item">
    <div class="item-title" (click)="showContents()">
      {{item.titleItem}}
      <app-custom-icons class="icon" [type]="showContent ? iconTypes.MINUS : iconTypes.PLUS"></app-custom-icons>
    </div>
    @if (showContent) {
      <div class="item-content">
        <div [@panelInOut]>
          {{item.content.content}}
        </div>
      </div>
    }
  </div>
}
